<template>
  <v-select
      v-if="devicesList"
      outlined
      dense
      :items="devicesList"
      :label="$t('windowReceiptsAdditional.kkm')"
      item-text="IdDevice"
      hide-details
      return-object
      v-model="selectedDevice"
  >
    <template v-slot:selection="{item}">
              <span  class="v-select__selection v-select__selection--comma">
              {{ item.NameDevice }}
              {{ item.KktNumber }}
              {{ item.TypeDevice }}
              </span>
    </template>
    <template v-slot:item="{item}" class="text-no-wrap">
              <span  class="v-select__selection v-select__selection--comma">
                {{ item.NameDevice }}
                {{ item.KktNumber }}
                {{ item.TypeDevice }}
              </span>
    </template>
  </v-select>
</template>

<script>
import {
  KKMListDevices
} from "@/plugins/kkm-server-api";
export default {
  name: "KkmSelect",
  data() {
    return {
      devicesList:null,
      selectedDevice: null
    }
  },
  mounted() {
    this.getDevices()
  },
  methods:{
    getDevices(){
      KKMListDevices((devicesData)=>{
        if(devicesData.Error!==''){
          this.$error(this.$t('windowReceiptsAdditional.error_getting_kkm')+' '+devicesData.Error)
        } else {
          this.devicesList = devicesData.ListUnit;
          this.fillSelectedDevice();
        }
      });
    },
    fillSelectedDevice(){
      if(!this.selectedDevice){
        let id = window.localStorage.getItem('KKMSelectedDeviceId');
        this.devicesList.forEach((device)=>{
          if(device.IdDevice === id){
            this.selectedDevice = device;
          }
        })
      }
    },
    emitNumDevice(){
      this.$emit('setNumDevice', this.kkmNumDevice)
    }
  },
  computed:{
    kkmNumDevice(){
      let numDevice = -1;
      let id
      if(this.selectedDevice && this.selectedDevice.IdDevice){
        id = this.selectedDevice.IdDevice
      } else {
        id = window.localStorage.getItem('KKMSelectedDeviceId');
      }
      this.devicesList.forEach((item)=>{
        if(item.IdDevice===id){
          numDevice =  item.NumDevice
        }
      })
      return numDevice;
    },
  },
  watch: {
    selectedDevice(device) {
      if (device.IdDevice) {
        window.localStorage.setItem('KKMSelectedDeviceId', device.IdDevice);
      } else {
        window.localStorage.setItem('KKMSelectedDeviceId', null);
      }
      this.emitNumDevice();
    },
  }
}
</script>

<style scoped>

</style>